module.exports = __webpack_public_path__ + "static/media/all.7751cf91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/all.svg
// module id = 355
// module chunks = 7